export class PayerBasicInfo {
    public  PayerId :number;
    public  Title :string;
    public  ForeignTitle :string;
}
